/* eslint-disable prefer-rest-params */
import { get, toArray } from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';

const createKeyedSelectorCreator = keyPath =>
  createSelectorCreator(calculateFn => {
    const memoizeFns = {};
    const defMemo = defaultMemoize(calculateFn);

    return function() {
      const keyValue = toArray(arguments).reduce(
        (foundValue, arg) => foundValue || get(arg, keyPath),
        '',
      );
      if (keyValue && !memoizeFns[keyValue]) {
        memoizeFns[keyValue] = defaultMemoize(calculateFn);
      }
      const memo = memoizeFns[keyValue] || defMemo;
      return memo.apply(null, arguments);
    };
  });

export default createKeyedSelectorCreator;
